module.exports = __webpack_public_path__ + "static/media/baor.0ec0a81b.wav";